import React from "react";

import { useGetFootprintingPorkPrimaryDataById, useTranslation } from "utils";

import { AlertBanner, Card, Flex, Icon, PageSpin, Tag, Typography } from "components";

interface GettingStartedProps {
  primaryDataId?: string;
}

const INFO_ITEMS = [
  "porkGettingStartedForm.info.gain",
  "porkGettingStartedForm.info.breakdown",
  "porkGettingStartedForm.info.compare",
  "porkGettingStartedForm.info.discover",
  "porkGettingStartedForm.info.track",
];

const PORK_LIST_FILES = ["feed", "forage", "agSupport", "nutrientManagement", "electricity", "diesel", "contractor"];

const GettingStartedForm = ({ primaryDataId }: GettingStartedProps) => {
  const { t } = useTranslation("footprintingPork");
  const { isLoading } = useGetFootprintingPorkPrimaryDataById(primaryDataId ?? "");

  if (isLoading) return <PageSpin />;

  return (
    <Flex vertical gap={16}>
      <Card border className="padding-200">
        {/* TODO: Replace with non-AI image */}
        {/* <Flex gap="1rem" vertical>
          <LazyLoadImage alt={"/images/onboarding/pork.jpg"} aria-label="farm-logo-image" src={"/images/onboarding/pork.webp"} />
        </Flex> */}
        <Flex gap={8} vertical>
          {INFO_ITEMS.map((item) => (
            <Flex key={item} align="center" gap={8}>
              <Icon size={24} iconName="tabler/circle-check" className="input-label-info-icon margin-left-0" />
              <Typography variant="paragraph-m">{t(item)}</Typography>
            </Flex>
          ))}
        </Flex>
      </Card>

      <Card border dataTestId="footprinting-pork-getting-started-form" className="padding-200">
        <Flex vertical gap={24}>
          <Flex vertical gap={4}>
            <Flex justify="space-between" align="center">
              <Typography variant="h3">{t("porkGettingStartedForm.documents")}</Typography>
              <Tag colour="blue" size="large" text={t("porkGettingStartedForm.tag")} className="center" />
            </Flex>
            <Typography variant="paragraph-m" color="grey-600" className="margin-0">
              {t("porkGettingStartedForm.documentsDescription")}
            </Typography>
          </Flex>

          <Flex vertical gap={4}>
            {PORK_LIST_FILES.map((file) => (
              <div key={file}>
                <Typography variant="paragraph-m" className="margin-right-50">
                  •
                </Typography>
                <Typography variant="paragraph-m">{t(`porkGettingStartedForm.porkListFiles.${file}`)}</Typography>
              </div>
            ))}
          </Flex>

          <AlertBanner
            headingSize="h6"
            gap={12}
            title={t("porkGettingStartedForm.alertBanner.title")}
            description={t("porkGettingStartedForm.alertBanner.description")}
            iconName="tabler/bulb"
            iconSize={24}
            type="recommended"
            iconAlign="start"
          />
        </Flex>
      </Card>

      <AlertBanner
        headingSize="h6"
        gap={12}
        title={t("porkGettingStartedForm.infoBanner.title")}
        description={t("porkGettingStartedForm.infoBanner.description")}
        iconName="tabler/info-circle"
        iconSize={24}
        type="info"
        iconAlign="start"
      />
    </Flex>
  );
};

GettingStartedForm.Key = "pork.gettingStarted";
export { GettingStartedForm };
